import { render, staticRenderFns } from "./RouteRuleActions.vue?vue&type=template&id=2f97b3da&scoped=true&"
import script from "./RouteRuleActions.vue?vue&type=script&lang=js&"
export * from "./RouteRuleActions.vue?vue&type=script&lang=js&"
import style0 from "./RouteRuleActions.vue?vue&type=style&index=0&id=2f97b3da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f97b3da",
  null
  
)

export default component.exports